import React, { ComponentProps } from 'react';
import ApexCharts from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

type TimeSeriesChartProps = {
  timeSeries: ApexAxisChartSeries;
  options: ApexOptions;
  type: ComponentProps<typeof ApexCharts>['type'];
  height?: ComponentProps<typeof ApexCharts>['height'];
};

export const TimeSeriesChart = ({
  timeSeries,
  options,
  type,
  height,
}: TimeSeriesChartProps) => (
  <ApexCharts
    type={type}
    options={options}
    series={timeSeries}
    height={height}
  />
);
